import { createContext } from 'react';

export const AudioPlayerContext = createContext<AudioPlayerContextProps>({
	url: null,
	isReady: false,
	isPlaying: false,
	setIsReady: () => {},
	artwork: undefined,
	setArtwork: () => {},
	title: undefined,
	setTitle: () => {},
	artist: undefined,
	setArtist: () => {},
	setAlbum: () => {},
	play: () => {},
	pause: () => {},
	close: () => {},
	playPause: () => {},
	toggleMute: () => {},
	progress: 0,
	setProgress: () => {},
	muted: false,
	setMuted: () => {},
	playedSeconds: 0,
	loadedSeconds: 0,
	loaded: 0,
	onProgressChange: () => {},
});

interface AudioPlayerContextProps {
	url: string | null;
	isReady: boolean;
	setIsReady: (isReady: boolean) => void;
	artwork?: Array<MediaImage>;
	setArtwork: (value: Array<MediaImage> | undefined) => void;
	title?: string;
	setTitle: (value: string | undefined) => void;
	artist?: string;
	setArtist: (value: string | undefined) => void;
	album?: string;
	setAlbum: (value: string | undefined) => void;
	isPlaying: boolean;
	play: () => void;
	pause: () => void;
	close: () => void;
	playPause: () => void;
	toggleMute: () => void;
	progress: number;
	setProgress: (progress: number) => void;
	muted: boolean;
	setMuted: (muted: boolean) => void;
	playedSeconds: number;
	loadedSeconds: number;
	loaded: number;
	onProgressChange: (progress: number, type: 'seconds' | 'fraction') => void;
}
